function sampleIdSelectDirective() {
	return {
		scope : {
			idSample : '=',
			onChange : '&?'
		},
		restrict : 'E',
		templateUrl : function(elem, attr) {
			return 'views/directives/sampleIdSelectdirective.html';
		},
		controller : [ '$scope', function($scope) {

			$scope.hasError = false;
			
			$scope.onRemove = function() {
				if ($scope.onChange)
					$scope.onChange({
						idSample : $scope.idSample.selected
					});
			}
			
			$scope.onSelect = function(item) {
				var patt = /^(\d+)?-?(\d+)?$/;
				if(!patt.test(item)){
					$scope.idSample.selected=[];
					$scope.hasError = true;
					return;
				}
				$scope.hasError = false;
				if ($scope.onChange)
					$scope.onChange();
			}
		} ],
		link : function(scope, element, attrs) {
//			scope.$watch('idSample', function(newValue, oldValue) {
//				scope.number = newValue;
//				scope.idSampleModel = newValue ? newValue : '';
//			}, true);
		}
	};
};

module.directive('sampleIdSelect', [ sampleIdSelectDirective ]);
